module.exports = __webpack_public_path__ + "img/objetivos_desarrollo.74f3bafc.webp";